<!-- ==================== Start confirm-delete popup =================== -->
<div>
  <h5 class="text-center head mb-70 bold">
    {{ "WelcomePleaseSignIn" | translate }}
  </h5>
  <div class="btns gap-10" [ngClass]="{ 'flex-h': !showGuestBtn }">
    <button
      *ngIf="showGuestBtn"
      (click)="onContinueAsGuest()"
      type="submit"
      class="main-btn sec animate border-0 w-100 mb-10"
      name="submit"
    >
      {{ "AuthWords.LoginAsGust" | translate }}
    </button>
    <button
      (click)="onSiginIn()"
      type="submit"
      class="main-btn sec animate border-0 w-100 mb-10"
      name="submit"
    >
      {{ "AuthWords.Login" | translate }}
    </button>
    <button
      (click)="onRegister()"
      type="button"
      class="main-btn sec animate border-0 w-100 mb-10"
      name="submit"
    >
      {{ "AuthWords.SignUp" | translate }}
    </button>
  </div>
</div>
<!-- ==================== End confirm-delete popup =================== -->
